import { Box, Typography } from "@mui/material";
import React from "react";
import i18n from "../i18n-config";
import { capitalizeFirstLetter } from "../utils/strings";

interface Props{
  title?: string;
}

function NoDataTable({ title = capitalizeFirstLetter(i18n.t("no_data")) }: Props) {
  return (
    <Box p={10}>
    <Typography
      textAlign={"center"}
      sx={{ position: "absolute", left: "50%" }}
    >
      {title}
    </Typography>
  </Box>
  );
}

export default NoDataTable;
